export default "<eci-tax-report-tab></eci-tax-report-tab>\n";